import { Link } from "react-router-dom";
import { config, navItems } from "@/config/eventConfig";

const CARD_LINES = {
  prompt_school:
    "Learn one framework for instructing AI, score your own prompt, then apply it to work you actually do.",
  build:
    "Scope one real project in a sentence, pick a recipe, and build something you can use next week.",
  mentors:
    "For the volunteers. Your role, your moves, and how to coach without driving.",
  stack: "What you keep after today, what it costs, and who should own it.",
};

const areaMinutes = (id) => {
  const a = config.areas.find((x) => x.id === id);
  const total = (a?.timers || []).reduce((s, t) => s + t.duration_minutes, 0);
  return total > 0 ? `${total} MINUTES` : null;
};

export const Home = () => (
  <div data-testid="home" className="min-h-screen bg-cream text-ink font-body">
    <div className="max-w-5xl mx-auto w-full px-6 py-12">
      {/* Hero */}
      <div className="bg-ink text-cream p-10 sm:p-14 mb-14">
        {config.event_subtitle && (
          <p className="mono-label text-cream/60 mb-4">{config.event_subtitle}</p>
        )}
        <h1 className="font-display text-5xl sm:text-6xl leading-none mb-5">
          {config.event_name}
        </h1>
        <p className="text-lg text-cream/90 max-w-2xl">
          A hands-on working session where nonprofit teams build real AI tools,
          with coaches beside them.
        </p>
      </div>

      {/* How today works */}
      <p className="mono-label text-ink/50 mb-3">How today works</p>
      <div className="space-y-3 mb-14">
        <div className="bg-white border border-sand p-5">
          You drive. If you are from a nonprofit, you are on the keyboard all
          day. The volunteers beside you are coaches, not drivers.
        </div>
        <div className="bg-white border border-sand p-5">
          Everything you need is on this screen. There is nothing to print,
          download, or install.
        </div>
        <div data-testid="home-data-rule" className="callout-warning">
          <p className="text-ink/80">{config.data_rule}</p>
        </div>
      </div>

      {/* Area cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
        {navItems.map((n, i) => (
          <Link
            key={n.slug}
            to={`/${n.slug}`}
            data-testid={`home-card-${n.slug}`}
            className="group bg-white border border-sand p-6 hover:border-orange transition-colors duration-150 block"
          >
            <div className="flex items-center justify-between mb-3">
              <span className="w-9 h-9 bg-teal text-white font-display text-xl leading-none flex items-center justify-center">
                {i + 1}
              </span>
              {areaMinutes(n.id) && (
                <span className="mono-label text-ink/40">{areaMinutes(n.id)}</span>
              )}
            </div>
            <p className="font-display text-2xl leading-none mb-2">{n.label}</p>
            <p className="text-sm text-ink/70">{CARD_LINES[n.id]}</p>
            <span className="text-orange group-hover:text-orange-dark mt-3 inline-block">
              &rarr;
            </span>
          </Link>
        ))}
      </div>

      <p className="text-ink/70">
        Follow your host. This screen matters most during Prompt School and The
        Build. For everything else, eyes up front.
      </p>
    </div>
  </div>
);
